const InitialState = { events: [], group: {}, select: {}, attr: {}, loading: true }

export const reducer: WidgetReducerType<ChartState, ChartMessage> = (state = InitialState, message) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    const { type, layer, events } = message
    switch (type) {
        case 'config':
            return {
                ...state,
                jsonConfig: message?.events?.jsonConfig
            }
        case 'start':
            const { group, select = [], fields } = events
            const isChartValue = (field: string) => field != 'timestamp' && !isAttr(field)
            const isAttr = (field: string) => field.startsWith('__')
            return {
                ...state,
                group: group,
                select: select.filter(e => isChartValue(e)),
                attr: Object.entries(fields).reduce((s, f) => (isAttr(f[0]) ? [...s, f[0]] : s), []) as string[]
            }

        case 'event':
            return {
                ...state,
                events,
                loading: false //TODO RESOLVE LOADING IN REPORT MAKER
            }
        // case 'endHistory':
        //     return {
        //         ...state
        //     }
        default:
            return state
    }
}
